import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const HeartIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path
        d="M22 11L12.5 21L7.5 16.5L3 12.5L1 10L0.5 7.5L1 5.5L2.5 3.5L5 2.5H7.5L10.5 4L12 5.5L14 3.5L16.5 2L19.5 2.5L21.5 4L23 6.5V9L22 11Z"
        fill={getColor(secondaryColor)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.74089 15.8016L12.0672 20.3451L20.9353 11.1831C22.7554 9.30267 22.7554 6.23158 20.9353 4.35111C19.1534 2.51022 16.2914 2.5008 14.4984 4.32877L11.9833 6.89301L9.44759 4.2733C7.67498 2.44193 4.82467 2.44193 3.05205 4.2733C1.23804 6.14742 1.25134 9.21193 3.08017 11.069L7.74089 15.8016ZM12.0572 22.7998L6.51961 16.9842L1.86892 12.2618C-0.607876 9.74682 -0.625118 5.62801 1.83053 3.09097C4.27124 0.569368 8.2284 0.569367 10.6691 3.09097L11.9914 4.45704L13.2848 3.13836C15.7476 0.627513 19.7102 0.641104 22.1568 3.16878C24.6149 5.70838 24.6149 9.82588 22.1568 12.3655L12.0572 22.7998Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default HeartIconFilled;
